import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appLinkButton]',
  standalone: true
})
export class LinkButtonDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) {
    const classes = ['btn', 'btn-link', 'text-uppercase', 'text-primary', "fs-button-small"];

    classes.forEach((className) => {
      this.renderer.addClass(this.el.nativeElement, className);
    });
  }
}
